import layout4 from './layout4/Layout4Config';

const FuseLayoutConfigs = {
	layout4,
};

export default FuseLayoutConfigs;
